var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticStyle:{"width":"100%","height":"100%","border":"0"},attrs:{"src":`https://www.youtube.com/embed/${_vm.getVideoId(_vm.url)}`,"allowfullscreen":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }